// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palace-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10H21V21H3V10H7Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M11.998 8.99805H12.002V9.00195H11.998V8.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4C14.7614 4 17 6.23858 17 9V10H21V21H3V10H7V9C7 6.23858 9.23858 4 12 4ZM12 4L12.002 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Palace3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'palace-3',
    ref,
    icon: element,
  },
));

Palace3Icon.displayName = 'Palace3Icon';

export default Palace3Icon;
